(function ($) {
    $(function () {

        var $slider = $('.event-list .slider'),
            $slides = $('.event-list .slider .event');

        $slider.each(function () {            

            var $this = $(this),
                currentSlide = 1,
                sliderExists = false,
                slideCount = 4;

            var hasSlides = $this.find(".event");

            if (hasSlides.length > 0) {

                if ($('#interior-2col').length) {
                    slideCount = 3;
                }

                var moves = [
                    {
                        min: 0,
                        max: 1539,
                        enter: function () {
                            if (sliderExists) {
                                sliderObj.destroy();
                                $slider.removeAttr('style');
                                $slides.removeAttr('style');
                                $this.find('.slidesContainer').removeAttr('style');
                                $slider.find('ul').removeAttr('style');

                                sliderExists = false;
                                $slider.removeClass('slider-active');
                            }
                        },
                        exit: function () { }
                    },
                    {
                        min: 1540,
                        max: 99999,
                        enter: function () {
                            sliderObj = $this.sudoSlider({
                                continuous: true,
                                responsive: true,
                                auto: false,
                                autoHeight: false,
                                speed: 500,
                                prevNext: true,
                                moveCount: slideCount,
                                slideCount: slideCount,
                                touch: true,
                                mouseTouch: false,
                                insertAfter: true,
                                initCallback: function () {
                                    sliderObj.getSlide(currentSlide).addClass('active');
                                    sliderExists = true;
                                    $slider.addClass('slider-active');
                                },
                                beforeAnimation: function (t) {
                                    sliderObj.getSlide(currentSlide).removeClass('active');
                                },
                                afterAnimation: function (t) {
                                    currentSlide = t;
                                    sliderObj.getSlide(t).addClass('active');
                                }
                            });

                            $(window).on('resize.sliderPause', function () { sliderObj.stopAnimation() });

                        },
                        exit: function () { }
                    }
                ];

                breakdance(moves);
            }

        });

    });
})($JQ);